<div class="graficos">
  <div class="fila-graficos1">
    <div class="chart-inicio" [routerLink]="['/contratista/docpropia']">
      <h2>{{ title_propio }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasPropio></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="chart-inicio" >
      <h2 [routerLink]="['/contratista/estado/centros']">{{ title_centros }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasCentros class="chartjs-render-monitor" (click)="showDataCentros($event)"></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="chart-inicio" >
      <h2 [routerLink]="['/contratista/estado/clientes']" >{{ title_clientes }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasClientes class="chartjs-render-monitor" (click)="showDataClientes($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fila-graficos2">
    <div class="chart-inicio" >
      <h2 [routerLink]="['/contratista/estado/gestores']">{{ title_gestores }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasGestores   class="chartjs-render-monitor" (click)="showDataGestores($event)" ></canvas>
          </div>
        </div>
      </div>
    </div>
    <div
      class="chart-inicio"
      
    >
      <h2 [routerLink]="['/contratista/estado/transportistas']" >{{ title_transportistas }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasTransportistas class="chartjs-render-monitor" (click)="showDataTransportistas($event)"></canvas>
          </div>
        </div>
      </div>
    </div>

  <!--   <div
      class="chart-inicio"
      [routerLink]="['/contratista/estado/instalaciones']"
    >
      <h2>{{ title_instalaciones }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasInstalaciones></canvas>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
<!-- <div class="cuenta-atras">
  Quedan
  <span class="dias">43 días</span>
  para que finalice tu licencia
</div>
 -->